import { eventBus } from "@/utils";

export default {
  methods: {
    encodeRoute: function (param) {
      return btoa(param);
    },

    decodeRoute: function (param) {
      return atob(param);
    },
  },

  mounted() {
    eventBus.$on("route-change", (params) => {
      this.$router.push({ name: params.name, params: { ...params.params } });
    });
  },
};
